"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingAPICall = void 0;
const fetchClient_1 = require("../../../utils/misc/fetchClient");
const env_config_1 = __importDefault(require("../../../env.config"));
const LoggingAPICall = (body) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${env_config_1.default.NODE_API_URL_CLIENT}/logging/v1`;
    try {
        return yield (0, fetchClient_1.fetchAtClientSideV2)({ url, body, method: "POST" });
    }
    catch (error) {
        console.error("Error in LoggingAPICall:", error);
        throw error;
    }
});
exports.LoggingAPICall = LoggingAPICall;
